import type { NavItems } from '@ksyos/design-system';
import { SideNav } from '@ksyos/design-system';
import { SideNavItem } from '@frontend/components/elements/navigation/components/SideNavItem';
import { useUiStateContext } from '@frontend/utils/hooks/useUiState';

export interface IPaymentsNavigationProps {
    navigationItems: NavItems[];
}

export function PaymentsNavigation(props: IPaymentsNavigationProps) {
    const { uiState, dispatchUiStateAction } = useUiStateContext();

    return (
        <SideNav>
            {props.navigationItems.map((item) => (
                <SideNavItem
                    defaultOpenKey="payments"
                    item={item}
                    key={item.key}
                    onClose={handleClose}
                />
            ))}
        </SideNav>
    );

    function handleClose() {
        if (uiState.isTopBarOpen) {
            dispatchUiStateAction({ isTopBarOpen: false, type: 'setIsTopBarOpen' });
        }
    }
}
